import { render, staticRenderFns } from "./DetailModify.vue?vue&type=template&id=d4d4b8da&scoped=true"
import script from "./DetailModify.vue?vue&type=script&lang=js"
export * from "./DetailModify.vue?vue&type=script&lang=js"
import style0 from "./DetailModify.vue?vue&type=style&index=0&id=d4d4b8da&prod&scoped=true&lang=css"
import style1 from "./DetailModify.vue?vue&type=style&index=1&id=d4d4b8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d4b8da",
  null
  
)

export default component.exports